export default __webpack_public_path__ + "static/Registered Welcome Church Location Marker-b5324ee9bc9c6d69384f5443e1bf41a1.svg";